// TWA and some PWAs block window.open popups. Fall back to same-tab navigation
// when the popup is blocked so external links still work.
export function openExternal(url: string): void {
  const win = window.open(url, '_blank', 'noopener,noreferrer');
  if (!win) window.location.href = url;
}
